import { useContext, useEffect } from 'react';

import MetadataContext from './MetadataContext';
import type { ILoadMetadata, IMetadataContext } from './types';

function useMetadata({
  loadOfficeLocationsData = false,
  loadPaymentTermsData = false,
  loadTransportMethodsData = false,
}: ILoadMetadata = {}): IMetadataContext {
  const metadataContext: IMetadataContext = useContext(MetadataContext);

  const {
    state: {
      officeLocationsLoadedProductType,
      paymentTermsLoadedProductType,
      transportMethodsLoaded,
      officeLocationsLoading,
      paymentTermsLoading,
      transportMethodsLoading,
      officeLocationsError,
      paymentTermsError,
      transportMethodsError,
    },
    actions: { loadOfficeLocations, loadPaymentTerms, loadTransportMethods },
  } = metadataContext;

  const shouldLoadOfficeLocations =
      loadOfficeLocationsData &&
      !officeLocationsLoadedProductType &&
      !officeLocationsLoading &&
      !officeLocationsError,
    shouldLoadPaymentTerms =
      loadPaymentTermsData &&
      !paymentTermsLoadedProductType &&
      !paymentTermsLoading &&
      !paymentTermsError,
    shouldLoadTransportMethods =
      loadTransportMethodsData &&
      !transportMethodsLoaded &&
      !transportMethodsLoading &&
      !transportMethodsError;

  useEffect(() => {
    if (shouldLoadOfficeLocations) {
      loadOfficeLocations();
    }
  }, [loadOfficeLocations, shouldLoadOfficeLocations]);

  useEffect(() => {
    if (shouldLoadPaymentTerms) {
      loadPaymentTerms();
    }
  }, [loadPaymentTerms, shouldLoadPaymentTerms]);

  useEffect(() => {
    if (shouldLoadTransportMethods) {
      loadTransportMethods();
    }
  }, [loadTransportMethods, shouldLoadTransportMethods]);

  return metadataContext;
}

export default useMetadata;
